module.exports = __webpack_public_path__ + "img/company_company-name.2b25de34.svg";